import styled from "@emotion/styled/macro";

export const DrawerWrapper = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    min-height: 60vh;
    max-height: 85vh;
    background: #FFFFFF;
    position: relative;
`;

export const DrawerHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 20px;
    border-bottom: 1px solid #E8E9ED;
    background: #FFFFFF;
    position: sticky;
    top: 0;
    z-index: 10;
`;

export const DrawerTitle = styled.div`
    font-family: Circular;
    font-weight: 500;
    font-size: 16px;
    line-height: 1.265;
    color: #1A1B1D;
`;

export const DrawerCloseButton = styled.button`
    background: none;
    border: none;
    cursor: pointer;
    padding: 8px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    
    &:hover {
        background: #F5F5F7;
    }
    
    &:active {
        background: #E8E9ED;
    }
`;

export const DrawerBody = styled.div`
    flex: 1;
    padding: 20px;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: 24px;
    min-height: 0;
    -webkit-overflow-scrolling: touch;
`;

export const DocumentSection = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px;
    background: #F8F9FA;
    border-radius: 12px;
    border: 1px solid #E8E9ED;
`;

export const DocumentInfo = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    flex: 1;
`;

export const DocumentIcon = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    flex-shrink: 0;
`;

export const DocumentName = styled.div`
    font-family: Circular;
    font-weight: 450;
    font-size: 14px;
    line-height: 1.265;
    color: #1A1B1D;
    flex: 1;
    word-break: break-word;
`;

export const SearchSection = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

export const SearchInputWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 0 16px;
    border: 1px solid #E8E9ED;
    border-radius: 40px;
    height: 48px;
    background: #FFFFFF;
    
    &:focus-within {
        border-color: #1A1B1D;
    }
`;

export const SearchInput = styled.input`
    border: none;
    outline: none;
    font-family: Circular;
    font-weight: 450;
    font-size: 14px;
    line-height: 1.265;
    color: #1A1B1D;
    flex: 1;
    background: transparent;
    
    &::placeholder {
        color: #9097A3;
    }
`;

export const SearchIcon = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    color: #9097A3;
`;

export const CreateTagSection = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

export const CreateTagLabel = styled.div`
    font-family: Circular;
    font-weight: 450;
    font-size: 14px;
    line-height: 1.265;
    color: #585D66;
`;

export const CreateTagInputWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 0 16px;
    border: 1px solid #E8E9ED;
    border-radius: 12px;
    height: 48px;
    background: #FFFFFF;
    
    &:focus-within {
        border-color: #1A1B1D;
    }
`;

export const PlusIcon = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
`;

export const CreateTagInput = styled.input`
    border: none;
    outline: none;
    font-family: Circular;
    font-weight: 450;
    font-size: 14px;
    line-height: 1.265;
    color: #1A1B1D;
    flex: 1;
    background: transparent;
    
    &::placeholder {
        color: #9097A3;
    }
`;

export const AddCustomTagButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    background: #1A1B1D;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    flex-shrink: 0;
    
    &:hover {
        background: #2A2B2D;
    }
    
    &:active {
        background: #000000;
    }
`;

export const TagSection = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

export const TagSectionTitle = styled.div`
    font-family: Circular;
    font-weight: 500;
    font-size: 14px;
    line-height: 1.265;
    color: #1A1B1D;
`;

export const SelectedTagsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const SelectedTag = styled.div`
    padding: 12px;
    background: #1A1B1D;
    border-radius: 12px;
    cursor: pointer;
    transition: all 0.2s ease;
    border: 1px solid transparent;
    
    &:active {
        transform: scale(0.98);
        background: #2A2B2D;
    }
`;

export const SelectedTagContent = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
`;

export const SelectedTagIcon = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    flex-shrink: 0;
`;

export const SelectedTagText = styled.div`
    font-family: Circular;
    font-weight: 450;
    font-size: 14px;
    line-height: 1.265;
    color: #FFFFFF;
    flex: 1;
`;

export const CheckmarkIcon = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    flex-shrink: 0;
`;

export const AllTagsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding-bottom: 96px;
    -webkit-overflow-scrolling: touch;
`;

export const TagOption = styled.div`
    padding: 12px;
    background: #FFFFFF;
    border: 1px solid #E8E9ED;
    border-radius: 12px;
    cursor: pointer;
    transition: all 0.2s ease;
    
    &:hover {
        background: #F8F9FA;
        border-color: #D0D5DD;
    }
    
    &:active {
        transform: scale(0.98);
        background: #F0F0F0;
    }
`;

export const TagOptionContent = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
`;

export const TagOptionIcon = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    flex-shrink: 0;
`;

export const TagOptionText = styled.div`
    font-family: Circular;
    font-weight: 450;
    font-size: 14px;
    line-height: 1.265;
    color: #1A1B1D;
    flex: 1;
`;

export const SaveButtonContainer = styled.div`
    padding: 16px 20px 20px;
    background: #FFFFFF;
    border-top: 1px solid #E8E9ED;
    position: sticky;
    bottom: 0;
`;

export const SaveButton = styled.button`
    width: 100%;
    height: 48px;
    background: #1A1B1D;
    color: #FFFFFF;
    border: none;
    border-radius: 12px;
    font-family: Circular;
    font-weight: 500;
    font-size: 16px;
    line-height: 1.265;
    cursor: pointer;
    transition: all 0.2s ease;
    
    &:hover {
        background: #2A2B2D;
    }
    
    &:active {
        transform: scale(0.98);
        background: #000000;
    }
    
    &:disabled {
        background: #E8E9ED;
        color: #9097A3;
        cursor: not-allowed;
        transform: none;
    }
`; 